import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

import { CONTENT_MAX_WIDTH } from 'modules/common';

import { Footer } from './components/Footer';
import { Header } from './components/Header';

interface Props {
  children: ReactNode;
}

export function Layout({ children }: Props): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.content}>{children}</div>
      <Footer />
    </div>
  );
}
const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    padding: theme.spacing(0, 10),
    backgroundColor: theme.palette.background.default,

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 8),
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 4),
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    margin: '0 auto',
  },
}));
